import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  AnalyticsService,
  DataService,
  LoansService,
  OperationsService,
  OptionsserviceService,
  StorageService
} from "../../../../_services/index";
import { HttpClient } from "@angular/common/http";
import {Location} from '@angular/common';

@Component({
  selector: "app-profileanalysis",
  templateUrl: "./profileanalysis.component.html",
  styleUrls: ["./profileanalysis.component.css"]
})
export class ProfileanalysisComponent implements OnInit {
  title = "Profile Analytics";
  details: any;
  phone_ownership: any;
  average_credit: any;
  average_income: any;
  salary_amount: any;
  token: any;
  @Input("parentRouteId") parentRouteId: any;
  loan: any;
  selected_analytics = "1";
  nodesandscores: any;
  analytics_result: any;
  sub: any;
  currentUser: any;
  data: any;
  view: any = "data";
  nodes_and_scores: any;
  analytics_last_done = "";
  customer: any;
  snapshot: any;
  showPicture = false;
  full_analytics: any;
  lender_id: any;
  borrower_id: any;
  principal: any;
  maturity_date: any;
  account_card_id: any;
  loan_request_id: any;
  card_id: any;
  sms_value: any;
  guarantor_value: any;
  call_logs_value: any;
  cards_value: any;
  profile_value: any;
  social_value: any;
  accounts_value: any;
  dd_value: any;
  repayment_value: any;
  params_result = false;
  passed_analytics: any;
  failed_analytics: any;
  number_passed: number;
  number_failed: number;
  profile_status: any;
  params: any = JSON.parse(localStorage.getItem("params"));
  analytics_score: number;
  compared_data: any;
  bvn_value: any;
  analytics: any;
  loading: boolean;
  analyzed_data: any[];
  highlights_score: any;
  customer_name: any;
  constructor(
    public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public dataService: DataService,
    public analyticsService: AnalyticsService,
    private http: HttpClient,
    public router: Router,
    private _location: Location,
  ) {
    this.currentUser = this.storageService.read<any>("currentUser");
    //this.profile_value = this.params.profile;
  }
  doingDisbursement(event) {}
  openOfferLetter(request_id) {
    this.router.navigate(["./applications/offerletter/" + request_id]);
  }
  dataView() {
    this.view = "data";
  }
  goBack() {
    this._location.back();
  }
  analyticsView() {
    this.view = "analytics";
  }
  ngOnInit() {
    this.getAnalyticsData();
    // this.getRequestParams();
    //this.getAnalytics();
  }
  // ngAfterViewInit() {
  //   this.getFullAnalytics();
  // }
  getAnalyticsData() {
    this.loading = true;
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params["id"];
      this.loansService
        .getProfileAnalyticsData(this.currentUser.token, this.parentRouteId)
        .subscribe(data => {
          this.loading = false;
          this.customer_name = data.loan.customer.legal_name;
          this.analytics_last_done = data.loan.analytics_summary.last_done;
          this.loan = data.loan;
          this.full_analytics = data.loan.analytics_summary;
          this.analytics = data.loan.analytics_summary.description.profile_;
          // this.failed_analytics = data.loan.analytics_summary.description.profile.failed;
          this.number_passed = data.loan.analytics_summary.counts.profile_passed;
          this.number_failed =  data.loan.analytics_summary.counts.profile_failed;
          this.profile_status = data.loan.analytics_summary.status.profile;
          this.analytics_score = data.loan.analytics_summary.final_analytics_score * 100;
          this.compared_data = data.loan.analytics_summary.profile_compared_data;
          this.highlights_score = data.loan.analytics_summary.output.profile.profile_scores;
          this.getCusomer(data.loan.people_id);
          this.dataService.onRequestLoadingEndFromBackend.emit({loan:data.loan});
          this.analyzed_data = this.analytics.filter(analysis => {
            return analysis.status === 'failed';
          });
        });
    });
  }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({
      section: section,
      request_id: this.parentRouteId
    });
  }
  getCusomer(people_id) {
    this.loansService
      .getLoanContractCustomer(this.currentUser.token, people_id)
      .subscribe(data => {
        this.customer = data.data;
      });
  }
  saveAnalytics(event) {
    this.loansService
      .saveProfileAnalysisData(
        this.currentUser.token,
        this.parentRouteId,
        this.nodes_and_scores,
        this.data
      )
      .subscribe(data => {
        this.data = data.result;
        this.details = data.result;
        this.nodes_and_scores = data.nodes_and_scores;
        this.analytics_last_done = data.analytics_last_done;
        this.loan = data.loan;
      });
  }
  modifyAnalytics() {
    this.dataService.onEditApplicationsModal.emit({
      section: "specific_analytics",
      request_id: this.parentRouteId,
      nodes_and_scores: this.nodes_and_scores,
      selected_analytics: "4",
      analytics_last_done: this.analytics_last_done,
      isedit: "1"
    });
  }
  getRequestParams() {
    return this.analyticsService.getRequestParams("13126").subscribe(res => {
      //console.log(res);
      this.params_result = true;
      this.lender_id = res.lender_id;
      this.borrower_id = res.borrower_id;
      this.principal = res.principal;
      this.maturity_date = res.maturity_date;
      this.account_card_id = res.account_card_id;
      this.loan_request_id = res.loan_request_id;
      this.card_id = res.card_id;
    });
  }
  getAnalytics() {
    return new Promise((resolve, reject) => {
      return this.http
        .post<any>(`https://eligibilitytest.creditclan.com/public/requestparams`, {
          request_id: "13126"
        })
        .toPromise()
        .then(res => {
          //console.log(res);
          this.lender_id = res.lender_id;
          this.borrower_id = res.borrower_id;
          this.principal = res.principal;
          this.maturity_date = res.maturity_date;
          this.account_card_id = res.account_card_id;
          this.loan_request_id = res.loan_request_id;
          this.card_id = res.card_id;
          resolve();
        })
        .then(res => {
          //console.log(res);
          this.getFullAnalytics();
        })
        .catch(err => {
          //console.log(err);
          reject();
        });
    });
  }
  getFullAnalytics() {
     
  }
}
